module.exports = __webpack_public_path__ + "static/media/mask-group-3@2x.d492225c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mask-group-3@2x.png
// module id = 589
// module chunks = 1